import { type ReactNode } from 'react';

import { getShownIndicators } from '../../core/components/annotations/components/indicators/utils/get-shown-indicators.js';
import { TimeseriesChartAnnotationsDataContext } from '../context/TimeseriesChartAnnotationsData.context.js';
import { useAnnotationsState } from '../hooks/store/selectors.js';
import { useAnnotationsConfig } from '../hooks/useAnnotationsConfig.js';

type TimeseriesAnnotationsDataProviderProps = {
  children: ReactNode;
};

export const TimeseriesAnnotationsDataProvider = (
  props: TimeseriesAnnotationsDataProviderProps,
) => {
  const selection = useAnnotationsState();
  const { tracks } = useAnnotationsConfig();
  const shownIndicators = getShownIndicators(tracks, selection);

  return (
    <TimeseriesChartAnnotationsDataContext.Provider
      value={{ indicators: shownIndicators }}
    >
      {props.children}
    </TimeseriesChartAnnotationsDataContext.Provider>
  );
};
